<template>
  <div class="dashboard">
    <div class="header">
      <div class="container">
        <router-link class="left" to="/">
          <img src="@/assets/logo.svg" alt="logo" width="40" height="40" />
          <label>{{ title }}</label>
        </router-link>
        <router-link to="/document">文档中心</router-link>
      </div>
    </div>
    <div class="main">
      <div class="container">
        <div v-for="area in area_list" :key="area.banner" class="area">
          <div class="banner">{{ area.banner }}</div>
          <div class="box">
            <router-link v-for="item in area.boxList" :key="item.title" class="item" :to="item.path">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
              <div class="badge" :class="item.status"></div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @description 仪表盘
 * @created 2024/04/19 14:41:57
 */
import { title } from "../../../package.json"
export default {
  meta: {
    title: "仪表盘"
  },
  name: "Dashboard",
  data() {
    return {
      title,
      area_list: [{
        banner: "开始使用",
        boxList: [{
          title: "物料二维码",
          desc: "按照一定的规则一键生成大量二维码",
          path: "/material-code",
          status: "success"
        }, {
          title: "Excel数据互转",
          desc: "支持数组、JSON等格式",
          path: "/excel-convert",
          status: "success"
        }, {
          title: "二维码解码",
          desc: "通过图片提取二维码",
          path: "/qrcode-decoder",
          status: "success"
        }, {
          title: "图片水印",
          desc: "覆盖原图输出水印图片",
          path: "/image-watermark",
          status: "warning"
        }, {
          title: "多尺寸图标批量生成",
          desc: "通过一张图片生成多个规格的图片",
          path: "",
          status: "error"
        }]
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
$maxWidth: 1200px;

.dashboard {
  min-height: 100vh;
  background-color: #f4f4f4;

  .header {
    top: 0;
    z-index: 9;
    position: sticky;
    backdrop-filter: blur(10px);
    background-color: hsla(0, 0%, 96%, .8);
    border-bottom: 1px solid rgba(0, 0, 0, .05);

    .container {
      height: 60px;
      margin: 0 auto;
      width: $maxWidth;
      @include flex(space-between);

      .left {
        @include flex();

        label {
          margin-left: 10px;
          font-weight: bold;
        }
      }

      a {
        font-size: 14px;
        color: #212224;
      }
    }
  }

  .main {
    margin-top: 40px;

    .container {
      margin: 0 auto;
      width: $maxWidth;

      .area {
        .banner {
          font-size: 26px;
          font-size: 18px;
          color: #212224;
        }

        .box {
          display: grid;
          grid-gap: 20px;
          margin-top: 20px;
          grid-template-columns: repeat(3, 1fr);

          .item {
            padding: 10px;
            cursor: pointer;
            overflow: hidden;
            position: relative;
            border-radius: 4px;
            box-sizing: border-box;
            background-color: #fff;

            .title {
              font-size: 18px;
              font-weight: 700;
              color: #4d4d4d;
            }

            .desc {
              font-size: 12px;
              margin-top: 10px;
              color: #757575;
            }

            .badge {
              top: -10px;
              right: -10px;
              width: 20px;
              height: 20px;
              position: absolute;
              transform: rotate(45deg);

              &.success {
                background-color: #28a745;
              }

              &.warning {
                background-color: #ffc107;
              }

              &.error {
                background-color: #dc3545;
              }
            }
          }
        }
      }
    }
  }
}
</style>
